import { Route, Routes } from 'react-router-dom'
import { useSyncStatus } from './api/hooks.js'
import { AuthGate } from './auth/AuthGate.js'
import { ErrorBoundary } from './components/ErrorBoundary.js'
import { Shell } from './components/Shell.js'
import { Calendar } from './routes/Calendar.js'
import { Exams } from './routes/Exams.js'
import { Grades } from './routes/Grades.js'
import { Review } from './routes/Review.js'
import { Week } from './routes/Week.js'
import { Work } from './routes/Work.js'

export function App() {
  return (
    <AuthGate>
      <Inner />
    </AuthGate>
  )
}

function Inner() {
  const status = useSyncStatus()

  return (
    <Shell review={status.data?.queue.pending}>
      <ErrorBoundary>
        <Routes>
        <Route path="/" element={<Week />} />
        <Route path="/week/:date" element={<Week />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/work" element={<Work />} />
        <Route path="/exams" element={<Exams />} />
        <Route path="/grades" element={<Grades />} />
          <Route path="/review" element={<Review />} />
        </Routes>
      </ErrorBoundary>
    </Shell>
  )
}
